import type { Language } from "../i18n/LanguageContext";

export type OrderCopy = {
  title: string;
  orderNumber: string;
  status: string;
  customer: string;
  deliveryAddress: string;
  selfPickup: string;
  dateRequested: string;
  dateDelivered: string;
  items: string;
  item: string;
  quantity: string;
  unitPrice: string;
  lineTotal: string;
  total: string;
  loading: string;
  notFoundTitle: string;
  notFoundText: string;
  errorTitle: string;
  errorText: string;
  retry: string;
  noItems: string;
  locale: string;
};

const ORDER_COPY: Record<Language, OrderCopy> = {
  ru: {
    title: "Ваш заказ",
    orderNumber: "Заказ №",
    status: "Статус",
    customer: "Клиент",
    deliveryAddress: "Адрес доставки",
    selfPickup: "Самовывоз",
    dateRequested: "Дата заказа",
    dateDelivered: "Дата доставки",
    items: "Состав заказа",
    item: "Наименование",
    quantity: "Кол-во",
    unitPrice: "Цена",
    lineTotal: "Сумма",
    total: "Итого",
    loading: "Загружаем заказ…",
    notFoundTitle: "Заказ не найден",
    notFoundText: "Проверьте ссылку — возможно, она устарела или указана с ошибкой.",
    errorTitle: "Не удалось загрузить заказ",
    errorText: "Попробуйте обновить страницу через несколько секунд.",
    retry: "Повторить",
    noItems: "В заказе пока нет позиций.",
    locale: "ru-RU"
  },
  kz: {
    title: "Сіздің тапсырысыңыз",
    orderNumber: "Тапсырыс №",
    status: "Күйі",
    customer: "Клиент",
    deliveryAddress: "Жеткізу мекенжайы",
    selfPickup: "Өзі алып кету",
    dateRequested: "Тапсырыс күні",
    dateDelivered: "Жеткізу күні",
    items: "Тапсырыс құрамы",
    item: "Атауы",
    quantity: "Саны",
    unitPrice: "Бағасы",
    lineTotal: "Сома",
    total: "Барлығы",
    loading: "Тапсырыс жүктелуде…",
    notFoundTitle: "Тапсырыс табылмады",
    notFoundText: "Сілтемені тексеріңіз — ол ескірген немесе қате болуы мүмкін.",
    errorTitle: "Тапсырысты жүктеу мүмкін болмады",
    errorText: "Бірнеше секундтан кейін бетті жаңартып көріңіз.",
    retry: "Қайталау",
    noItems: "Тапсырыста әзірге позициялар жоқ.",
    locale: "kk-KZ"
  },
  en: {
    title: "Your order",
    orderNumber: "Order #",
    status: "Status",
    customer: "Customer",
    deliveryAddress: "Delivery address",
    selfPickup: "Self pickup",
    dateRequested: "Order date",
    dateDelivered: "Delivery date",
    items: "Order items",
    item: "Item",
    quantity: "Qty",
    unitPrice: "Unit price",
    lineTotal: "Total",
    total: "Total",
    loading: "Loading order…",
    notFoundTitle: "Order not found",
    notFoundText: "Check the link — it may be outdated or mistyped.",
    errorTitle: "Couldn't load the order",
    errorText: "Please refresh the page in a few seconds.",
    retry: "Retry",
    noItems: "This order has no items yet.",
    locale: "en-US"
  }
};

export function getOrderCopy(language: Language): OrderCopy {
  return ORDER_COPY[language] ?? ORDER_COPY.ru;
}
